import get from 'lodash/get';
import each from 'lodash/each';
import store from '@/store';
import http from '../../api';

/**
 * @param {File} file
 */
export async function uploadFile(file) {
  try {
    const formData = new FormData();

    formData.append('file', file, file.name);
    formData.append('title', file.name);

    if (file.description) {
      formData.append('description', file.description);
    }

    return (await http.post('/attachments/upload', formData)).data;
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(e);
    }

    throw e;
  }
}

export async function uploadOrthophotomap(chunk, file, chunkStart, chunkEnd) {
  try {
    const data = new FormData();
    data.append('file', chunk, file.name);

    data.append('start', chunkStart);
    data.append('end', chunkEnd);

    const response = await http.post('admin/orthophotomaps/upload', data, {
      headers: {
        'Content-Range': `bytes ${chunkStart}-${chunkEnd - 1}/${file.size}`,
      },
    });
    return response;
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(e);
    }

    throw e;
  }
}

export async function uploadImportFile(file, fileType, objectId, objectType) {
  try {
    const data = new FormData();
    data.append('file', file, file.name);
    data.append('type', fileType);
    data.append('objectId', objectId);
    data.append('objectType', objectType);

    const response = await http.post('/import-service/upload', data);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error);
    }

    const code = get(error, 'response.data.data.code') || get(error, 'response.status');
    const errorMessage = error?.response?.data?.message || error?.response?.data?.data?.message;

    if (code === 100) {
      store.dispatch('showNotify', { type: 'error', message: 'Файл уже был импортирован ранее' });
    } else {
      store.dispatch('showNotify', {
        type: 'error',
        message: errorMessage || 'Что-то пошло не так...',
      });
      throw error;
    }
  }
}

export async function requestImportableSummary(importDataId, byTwoCoords, geometryFields) {
  try {
    const response = await http.post(`/import-service/${importDataId}/importable-summary`, {
      byTwoCoords,
      geometryFields,
    });

    return response.data;
  } catch (error) {
    store.dispatch('showNotify', { type: 'error', message: 'Что-то пошло не так...' });

    console.error(error);
  }
}

export async function uploadAttachments(id, data) {
  const formData = new FormData();

  each(data, (item) => {
    formData.append('files[]', item, item.name);
  });

  try {
    const response = await http.post(`admin/layer-objects/${id}/attachment`, formData);
    return response;
  } catch (e) {
    store.dispatch('showNotify', { type: 'error', message: 'Что-то пошло не так' });
    throw e;
  }
}
